function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#adc6ca",
  fillRule: "evenodd",
  d: "M13.658 10.48l-2.625-1.125a.564.564 0 00-.657.161l-1.162 1.42a8.683 8.683 0 01-4.153-4.152L6.48 5.62a.561.561 0 00.162-.656L5.518 2.34a.567.567 0 00-.645-.326l-2.437.563A.562.562 0 002 3.125C2 9.137 6.873 14 12.875 14a.56.56 0 00.548-.436l.563-2.437a.57.57 0 00-.328-.647z"
});

function SvgPhoneinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgPhoneinline;